import { HttpMethod } from '@lg/shared'
import { ErrorService } from './error.service.js'
import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http'
import { Observable, of, throwError } from 'rxjs'
import { catchError, retry } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { AppContext } from '../app-context.js'

interface GetOptions {
	headers?: {
		[header: string]: string | string[]
	}
	// observe?: 'body';
	// context?: HttpContext;
	params?:
		| HttpParams
		| {
				[param: string]:
					| string
					| number
					| boolean
					| ReadonlyArray<string | number | boolean>
		  }
	reportProgress?: boolean
	// responseType?: 'json';
	withCredentials?: boolean
}

@Injectable({
	providedIn: 'root',
})
export class BackendService {
	private readonly port = 8080 //window.location.port

	private baseURL = `//${window.location.hostname}:${this.port}/api/${AppContext.appModuleId}/` // ADAPT

	constructor(
		private http: HttpClient,
		private errorService: ErrorService,
	) {}

	getData<T>(url: string, options: GetOptions): Observable<T | null> {
		const x = this.http.get<T>('', {
			...options,
			observe: 'body',
			responseType: 'json',
		})

		return this.http
			.get<T>(this.baseURL + url, {
				...options,
				observe: 'body',
				responseType: 'json',
			})
			.pipe(
				catchError((err) => {
					this.errorService.error(err)
					return of(null)
				}),
			)
	}

	callAndGetResponse<T>(
		method: HttpMethod,
		url: string,
		body: any,
		params: Record<string, any>,
	): Observable<T | null> {
		return this.http
			.request<T>(method, this.baseURL + url, {
				body,
				params,
				responseType: 'json',
			})
			.pipe(
				catchError((err) => {
					this.errorService.error(err)
					return of(null)
				}),
			)
	}
}
